<template>
    <el-autocomplete
            class="trade-search"
            popper-class="trade-sear-kuang"
            :fetch-suggestions="querySearch"
            @select="handleSelect"
            valueKey="name"
            placeholder="请输入股票代码/名称"
            v-model="searchKeyWord">
        <i slot="suffix" class="el-input__icon el-icon-search"></i>
        <template slot-scope="props">
            <template v-if="props.item.code !== 500">
                <span class="search addZix"
                      @click.stop="addToZixuan(props.item.symbol, props.item.name, props.item.ctrl, $event)">{{props.item.ctrl}}</span>
                <span class="search symbol">{{ props.item.symbol }}</span>
                <span class="search name">{{ props.item.name }}</span>
            </template>
            <template v-else>
                <span class="search name">{{ props.item.msg }}</span>
            </template>
        </template>
    </el-autocomplete>
</template>

<script>
    export default {
        name: "BaseHeaderSearch",
        methods: {
            querySearch(queryString, cb) {
                this.queryString = queryString;
                this.cb = cb;
                if (queryString !== '') {
                    this.$api.searchGp(queryString, this.$store.state.now_token, this.$store.state.now_trade_account).then(res => {
                        if (res.data.code === 200) {
                            cb(this.isZixuan(res.data.data))
                        } else if (!res.data.hasOwnProperty('code')) {
                            cb([{code: 500, msg: '暂无自选'}])
                        } else {
                            cb([res.data])
                        }
                    })
                }
            },
            /**
             * 设置当前激活股票，并跳转到指定股票详情页
             * 判断是否为大盘，大盘跳转1，股票跳转2
             * @param item 选中的搜索结果
             */
            handleSelect(item) {
                if (this.$store.state.gupiaolist_dp) {
                    if (this.$store.state.gupiaolist_dp.result.indexOf(item.symbol.toLocaleUpperCase()) > -1) {
                        // this.$store.commit('SET_FOUCS_DP', item.symbol.toLocaleUpperCase());
                        // if (this.$route.name === 'trade') {
                        //     this.$router.push({path: '/detail/1'});
                        // }
                        // if (this.$route.name === 'detail' && +this.$route.params.type !== 1) {
                        //     this.$router.replace({path: '/detail/1'});
                        // }
                    } else {
                        this.$store.commit('SET_FOUCS_GP', item.symbol);
                        this.$store.commit('SCROLL_TO_ITEM');
                    }
                }
            },
            addToZixuan(symbol, name, ctrl) {
                if (ctrl === '+') {
                    this.$api.addChooseStock(this.$store.state.now_token, this.$store.state.now_trade_account, symbol, name).then(res => {
                        this.$notify({
                            message: res.data.data,
                            position: 'bottom-right',
                            type: 'success'
                        });
                        this.querySearch(this.queryString, this.cb);
                        this.$store.commit('UP_ZIXUAN', Math.random() * 999999);
                    })
                } else {
                    this.$api.deleteChooseStock(this.$store.state.now_token, this.$store.state.now_trade_account, symbol).then(res => {
                        this.$notify({
                            message: res.data.data,
                            position: 'bottom-right',
                            type: 'success'
                        });
                        this.querySearch(this.queryString, this.cb);
                        this.$store.commit('UP_ZIXUAN', Math.random() * 999999);
                    })
                }
            },
            isZixuan(symbols) {
                symbols.map((v, i) => {
                    if (v.is_zx === 1) {
                        symbols[i]['ctrl'] = '-';
                    } else {
                        symbols[i]['ctrl'] = '+';
                    }
                });
                return symbols;

                // if (i === symbols.length - 1) {
                //     resolve(symbols);
                // } else {
                //     f_(++i);
                // }
            }
        },
        created() {
        },
        data: function () {
            return {
                searchKeyWord_: '',
                searchGpList: [],
                searchKeyWord: '',
                searchHistory: [],
                queryString: null,
                cb: null
            }
        }
    }
</script>

<style scoped lang="scss">
    .trade-sear-kuang {
        overflow: hidden;
    }

    .fade-enter-active, .fade-leave-active {
        transition: all .5s;
    }

    .fade-enter, .fade-leave-to {
        height: 0;
    }
</style>
